import { render, staticRenderFns } from "./ConsentAttachments.vue?vue&type=template&id=ee2377bc"
import script from "./ConsentAttachments.vue?vue&type=script&lang=js"
export * from "./ConsentAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports